import { z } from 'zod';
import { BackendCompatibleLocales } from '../../enums';

export const TicketLimitFormValidatorSchema = z.object({
  name: z
    .partialRecord(z.enum(BackendCompatibleLocales), z.string())
    .refine((name) => !!name.en?.trim(), {
      message: 'ticket_limit_name_required',
    }),
  ticketsPerPerson: z
    .number('ticket_limit_tickets_per_person_invalid')
    .int('ticket_limit_tickets_per_person_invalid')
    .min(1, 'ticket_limit_tickets_per_person_invalid'),
});

export type TicketLimitFormValidator = z.infer<
  typeof TicketLimitFormValidatorSchema
>;
